module.exports = __webpack_public_path__ + "static/Phone-112a1151d16abe65746d43807e70936b.png";